<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import { debounce } from "../../../helpers/helper";
//import axios from 'axios';
//import store from '@/state/store'
/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Events",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
  },
  data() {
    const { perPage, status, orderBy, sortBy } = this.$route.query;
    return {
      exporting: false,
      sortBy: sortBy || "created_at",
      sortDesc: orderBy && orderBy != "" ? orderBy : true,
      limit: 10,
      perPage: perPage || 10,
      search: "",
      event_image: process.env.VUE_APP_MIX_BASE_URL + "images/app_icon.png",
      status: status == undefined ? "1" : status,
      searchData: debounce(() => {
        const { perPage, status, orderBy, sortBy } = this.$data;
        this.$router.replace({
          name: "event.list",
          query: { perPage, status, orderBy, sortBy },
        });
        let page = 1;
        this.getEventsList({
          page: page,
          perPage: this.perPage,
          search: this.search,
          status: this.status,
          sortBy: this.sortBy,
          orderBy: this.sortDesc ? "desc" : "asc",
        });
      }, 500),
      fields: [
        {
          key: "id",
          label: this.$t("userManagement.list.ID"),
          sortable: true,
        },
        {
          key: "name",
          label: this.$t("userManagement.list.name"),
          sortable: true,
          tdClass: "w-75",
        },
        // {
        //   key: "attendees",
        //   label: this.$t("userManagement.list.attendees"),
        //   sortable: true,
        // },
        // {
        //   key: "phone_number",
        //   label: this.$t("userManagement.list.phoneNumber"),
        //   sortable: true,
        // },
        {
          key: "is_active",
          label: this.$t("userManagement.list.status"),
          sortable: false,
        },
        {
          key: "action",
          label: this.$t("userManagement.list.action"),
          sortable: false,
        },
      ],
    };
  },

  computed: mapGetters("event", [
    "loading",
    "eventCount",
    "eventData",
    "events",
    "paginations",
  ]),
  mounted() {
    let orderBy = this.sortDesc ? "desc" : "asc";
    let page = 1;
    this.getEventsList({
      page: page,
      perPage: this.perPage,
      search: this.search,
      status: this.status,
      sortBy: this.sortBy,
      orderBy: orderBy,
    });
  },
  methods: {
    ...mapActions("event", ["getEventsList", "getExportCSVData", "deleteEvent"]),

    downloadsCSV: function () {
      this.exporting = true;
      this.getExportCSVData({
        search: this.search,
        status: this.status,
        sortBy: this.sortBy,
        orderBy: this.sortDesc ? "desc" : "asc",
      }).then((res) => {
        this.exporting = false;
        if (res) {
          let eventData = "\ufeff" + "Id,Name,DateTime,Attendees,Type,Status\n";
          this.eventData.forEach((el) => {
            var line =
              el["id"] +
              "," +
              el["name"] +
              "," +
              el["event_date"].replaceAll(",", " ") +
              "," +
              el["events_attendees_count"] +
              "," +
              el["type"] +
              "," +
              (el["is_active"] == 1 ? "Active" : "InActive") +
              "\n";
            eventData += line;
          });
          var blob = new Blob([eventData], { type: "csv/plain" });
          var date = new Date().toLocaleString();
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "Events" + date + ".csv";
          link.click();
        }
      });
    },

    sortingChanged(ctx) {
      let page = 1;
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getEventsList({
        page: page,
        perPage: this.perPage,
        search: this.search,
        status: this.status,
        sortBy: this.sortBy,
        orderBy: this.sortDesc,
      });
      // this.getExportCSVData({
      //   page: page,
      //   search: this.search,
      //   status: this.status,
      //   sortBy: this.sortBy,
      //   orderBy: this.sortDesc,
      // });
    },
    getEvents(page = 1) {
      let orderBy = this.sortDesc ? "desc" : "asc";
      this.getEventsList({
        page: page,
        perPage: this.perPage,
        search: this.search,
        status: this.status,
        sortBy: this.sortBy,
        orderBy: orderBy,
      });
      //   this.getExportCSVData({
      //     page: page,
      //     search: this.search,
      //     status: this.status,
      //     sortBy: this.sortBy,
      //     orderBy: orderBy,
      //  });
    },
    deleteEventName(id) {
      if (confirm("Are you sure want to delete?")) {
        this.deleteEvent(id).then((res) => {
          if (res) this.getEvents(this.paginations.meta.current_page);
        });
      }
    },
    imageNotFound(event) {
      event.target.src = process.env.VUE_APP_MIX_BASE_URL + "images/app_icon.png";
    },
    getImgUrl(image) {
      let path = process.env.VUE_APP_MIX_BASE_URL + "media/event/original/";
      return require(path + image);
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
        >
          <div class="page-title-left">
            <div class="avatar-xs mr-3">
              <!-- <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                                <i class="bx-category-alt"></i>
                            </span> -->
            </div>
            <div class="report-tag">
              <h4 class="mb-0 font-size-18">Events({{ eventCount }})</h4>
            </div>
          </div>
          <div class="page-title-right d-flex">
            <router-link
              :to="{ name: 'event.add' }"
              class="btn btn-success btn-rounded mr-2 add-btn"
            >
              <i class="mdi mdi-plus mr-1"></i>{{ $t("add_event") }}
            </router-link>
            <button
              @click="downloadsCSV"
              class="btn btn-primary btn-rounded export-btn"
              :disabled="exporting"
            >
              {{ exporting ? $t("Exporting...") : $t("export_csv") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row list-table-main">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-2 offset-sm-6">
                <div class="form-group">
                  <div class="date-range-list">
                    <label>Per Page :</label>
                    <select
                      class="custom-select"
                      v-model="perPage"
                      @change="searchData()"
                    >
                      <option value="10" selected>10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group">
                  <div class="date-range-list">
                    <label>Status :</label>
                    <select class="custom-select" v-model="status" @change="searchData()">
                      <option value="">Both</option>
                      <option value="1" selected>Active</option>
                      <option value="0">InActive</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-sm-2">
                <div class="date-range-list">
                  <label>Search :</label>
                  <div class="text-sm-right">
                    <div class="search-box mr-2 d-inline-block">
                      <div class="position-relative">
                        <input
                          type="text"
                          class="form-control"
                          id="search"
                          @input="searchData()"
                          v-model="search"
                          :placeholder="$t('navbar.search.text')"
                        />
                        <i class="bx bx-search-alt search-icon"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 table-main-list customer-table table-responsive">
                <b-table
                  :items="events"
                  :fields="fields"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :no-local-sorting="true"
                  @sort-changed="sortingChanged"
                  :busy="loading"
                  show-empty
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>{{ $t("loadingData") }}</strong>
                    </div>
                  </template>
                  <template v-slot:cell(id)="data">
                    <h5 class="font-size-14">{{ data.item.id }}</h5>
                  </template>
                  <template v-slot:cell(name)="data">
                    <!-- <h5 class="font-size-14">{{ data.item.name }}</h5> -->
                    <div class="d-flex">
                      <img
                        v-if="data.item.events_images[0]"
                        :src="data.item.events_images[0]"
                        alt=""
                        class="rounded-circle avatar-xs mr-3"
                        @error="imageNotFound"
                      />
                      <img
                        v-else
                        :src="event_image"
                        alt=""
                        class="rounded-circle avatar-xs mr-3"
                      />

                      <div>
                        <span class="font-size-15 mr-auto">{{ data.value }} </span>
                        <small v-if="data.item.type == 'Online'" class="text-success">{{
                          data.item.type ? "(" + data.item.type + ")" : ""
                        }}</small>
                        <small
                          v-else-if="data.item.type == 'Hybrid'"
                          class="text-primary"
                          >{{ data.item.type ? "(" + data.item.type + ")" : "" }}</small
                        >
                        <small v-else class="text-danger">{{
                          data.item.type ? "(" + data.item.type + ")" : ""
                        }}</small>
                        <br />
                        <small class="text-muted">{{ data.item.event_date }}</small>
                      </div>
                    </div>
                  </template>
                  <!-- <template v-slot:cell(attendees)="data">
                    <h5 class="font-size-14">{{ data.item.events_attendees_count }}</h5>
                  </template> -->
                  <template v-slot:cell(is_active)="data">
                    <div
                      v-if="data.item.is_active == '1'"
                      class="badge badge-pill badge-soft-success font-size-12 mt-2"
                    >
                      Active
                    </div>
                    <div
                      v-else
                      class="badge badge-pill badge-soft-danger font-size-12 mt-2"
                    >
                      InActive
                    </div>
                  </template>

                  <template v-slot:cell(action)="data">
                    <div class="page-title-right d-flex">
                      <router-link
                        :to="{ name: 'event.edit', params: { id: data.item.id } }"
                        class="btn btn-success btn-rounded mr-2 add-btn"
                      >
                        Edit
                      </router-link>
                      <!-- <router-link
                        :to="{ name: 'event.show', params: { id: data.item.id } }"
                        class="btn btn-primary btn-rounded mr-2 add-btn"
                      >
                        Show
                      </router-link> -->
                      <button
                        @click="deleteEventName(data.item.id)"
                        class="btn btn-danger btn-rounded export-btn"
                      >
                        Delete
                      </button>
                    </div>
                  </template>
                  <template #empty>
                    <p class="text-center">No events yet</p>
                  </template>
                </b-table>
              </div>
              <div class="row col-sm-5 offset-sm-7">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <pagination
                        :data="paginations"
                        :limit="limit"
                        @pagination-change-page="getEvents"
                      ></pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
